import {
  Completion, HouseholdItem, Person, Project, PROJECT_COLORS, Recurrence,
} from './types';

export const todayStr = (): string => new Date().toISOString().slice(0, 10);

export const newId = (): string => (
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `id-${Date.now()}-${Math.random().toString(16).slice(2)}`
);

export const nextDueDate = (fromDate: string, recurrence: Recurrence): string => {
  const date = new Date(`${fromDate}T00:00:00`);
  switch (recurrence) {
    case 'daily':
      date.setDate(date.getDate() + 1);
      break;
    case 'weekly':
      date.setDate(date.getDate() + 7);
      break;
    case 'biweekly':
      date.setDate(date.getDate() + 14);
      break;
    case 'monthly':
      date.setMonth(date.getMonth() + 1);
      break;
    default:
      break;
  }
  return date.toISOString().slice(0, 10);
};

export const isOverdue = (item: HouseholdItem): boolean => (
  !!item.dueDate && item.dueDate < todayStr() && item.status !== 'done'
);

export const daysUntil = (dueDate: string): number => {
  const today = new Date(`${todayStr()}T00:00:00`);
  const due = new Date(`${dueDate}T00:00:00`);
  return Math.round((due.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
};

export interface FairnessTotals {
  totalEffort: Record<Person, number>;
  completedCount: Record<Person, number>;
}

export const computeFairness = (
  completions: Completion[],
  sinceDate?: string
): FairnessTotals => {
  const totals: FairnessTotals = {
    totalEffort: { Patrick: 0, Prapti: 0 },
    completedCount: { Patrick: 0, Prapti: 0 },
  };
  completions
    .filter((c) => !sinceDate || c.completedAt.slice(0, 10) >= sinceDate)
    .forEach((c) => {
      totals.totalEffort[c.assignee] += c.effort ?? 0;
      totals.completedCount[c.assignee] += 1;
    });
  return totals;
};

export const nextProjectColor = (existingProjects: Project[]): string => (
  PROJECT_COLORS[existingProjects.length % PROJECT_COLORS.length]
);

export const last30DaysDate = (): string => {
  const date = new Date();
  date.setDate(date.getDate() - 30);
  return date.toISOString().slice(0, 10);
};
